<template>
  <v-dialog max-width="480px" v-model="showDialog" persistent>
    <v-card>
      <v-card-title class="secondary white--text py-3 px-5">
        <span class="text-subtitle-1 font-weight-bold">Update Container No</span>
        <v-spacer />
        <v-btn icon color="white" small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-5 pt-4">
        <div class="caption grey--text mb-3" v-if="trip">
          <strong>{{ trip.trip_id }}</strong> · Driver: {{ trip.driver_name || "-" }}
        </div>
        <v-select
          label="Container No *"
          :items="containerList"
          item-text="display_label"
          item-value="id"
          :loading="containerLoading"
          outlined
          dense
          hide-details="auto"
          v-model="selectedContainer"
          no-data-text="No pending containers available"
        />
      </v-card-text>

      <v-divider class="mt-3" />

      <v-card-actions class="px-5 py-3">
        <v-spacer />
        <v-btn depressed outlined @click="closeDialog" class="mr-2">Cancel</v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="submitting"
          :disabled="!selectedContainer"
          min-width="120"
          @click="submit"
        >
          Assign
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UpdateContainerDialog",
  props: {
    value: { type: Boolean, default: false },
    trip: { type: Object, default: null },
  },
  watch: {
    value(val) {
      if (val) {
        this.selectedContainer = null;
        this.fetchPendingContainers();
      }
    },
  },
  data() {
    return {
      containerList: [],
      containerLoading: false,
      selectedContainer: null,
      submitting: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    fetchPendingContainers() {
      this.containerLoading = true;
      this.$api.nonBondedContainer
        .getNonBondedContainerList({ status: "Pending", limit: 200 })
        .then((res) => {
          this.containerList = (res.data || []).map((c) => ({
            ...c,
            display_label: c.container_type_name
              ? `${c.container_number} — ${c.container_type_name}`
              : c.container_number,
          }));
        })
        .finally(() => {
          this.containerLoading = false;
        });
    },
    submit() {
      if (!this.trip || !this.selectedContainer) return;
      this.submitting = true;
      this.$api.nonBondedContainer
        .assignNonBondedContainerToTrip(this.selectedContainer, this.trip.id)
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Container assigned successfully!",
            color: "success",
          });
          this.$emit("updated");
          this.closeDialog();
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message:
              (err?.data?.container && err.data.container) ||
              err?.data?.trip ||
              err?.data?.detail ||
              err?.message ||
              "Failed to assign container.",
            color: "error",
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
